/**
 * Legacy (tier-based) plan display details. Used only when pricingModel === 'plan_tier_based_v1'.
 */

export const DEFAULT_LEGACY_PLAN: {
  name: string
  price: number
  credentials: number | string
} = { name: 'Starter', price: 150, credentials: 3 }

export const LEGACY_TIER_DETAILS: Record<
  string,
  { name: string; price: number; credentials: number | string }
> = {
  starter: DEFAULT_LEGACY_PLAN,
  pro: { name: 'Pro', price: 300, credentials: 10 },
  power: { name: 'Power', price: 500, credentials: 'Unlimited' }
}
